module.exports = __webpack_public_path__ + "img/selected7-min.f23ca59e.png";